import { createConfig, configureChains } from 'wagmi'
import { polygon } from 'wagmi/chains'

import { alchemyProvider } from 'wagmi/providers/alchemy'
import { publicProvider } from 'wagmi/providers/public'

import { MetaMaskConnector } from 'wagmi/connectors/metaMask'

export class MetamaskService {
  client
  connector

  constructor() {
    const apiKey = process.env.REACT_APP_ALCHEMY_PROJECT_ID
    if (!apiKey) {
      return
    }

    const { chains, publicClient, webSocketPublicClient } = configureChains(
      [polygon],
      [alchemyProvider({ apiKey: apiKey as string }), publicProvider()]
    )

    const connectorMetaMask = new MetaMaskConnector({ chains })
    this.connector = connectorMetaMask

    this.client = createConfig({
      autoConnect: false,
      connectors: [connectorMetaMask],
      publicClient,
      webSocketPublicClient,
    })
  }
}
